import { ValidationErrors, ValidatorFn, AbstractControl,Validators } from "@angular/forms";

export class CustomValidators {
    static patternValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
      return (control: AbstractControl): { [key: string]: any } => {
        if (!control.value) {
          return null;
        }
        const valid = regex.test(control.value);
        return valid ? null : error;
      };
    }
  
    static passwordMatchValidator(control: AbstractControl) {
      const password: string = control.get('Password').value; 
      const confirmPassword: string = control.get('RePassword').value; 
      if (password !== confirmPassword) {
        control.get('RePassword').setErrors({ NoPassswordMatch: true });
      }
    }
  
    static activeValidatorsWeekDays(control: AbstractControl) {
      const isActive: boolean = control.get('isActive').value; 
      if (isActive) {
        control.get("StartTime").setValidators([Validators.required]);
        control.get("EndTime").setValidators([Validators.required]);
      }else{
        control.get("StartTime").setValidators(null);
        control.get("EndTime").setValidators(null);
      }
    }

    static activeValidatorsTimeSheetWeekDays(control: AbstractControl) {
      const isActive: boolean = control.get('isActive').value; 
      if (isActive) {
        control.get("TimeStart").setValidators([Validators.required]);
        control.get("TimeEnd").setValidators([Validators.required]);
      }else{
        control.get("TimeStart").setValidators(null);
        control.get("TimeEnd").setValidators(null);
      }
    }

    static TimeValidator(control: AbstractControl) {
      if (control.get("TimeStart").value) {
        control.get("TimeEnd").setValidators([Validators.required]);
      }
    }

  }